import { Component, Input, AfterContentInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Language } from '../../../tools/language/language';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { FixedBoxControlService } from 'src/app/services/fixed-box-control/fixed-box-control.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PrivatePolicyTemplateSheetComponent } from 'src/app/tools/templatesheets/private-policy-template-sheet/private-policy-template-sheet.component';
import { TerminsAndConditionsTemplateSheetComponent } from 'src/app/tools/templatesheets/termins-and-conditions-template-sheet/termins-and-conditions-template-sheet.component';
import { TerminsOfServiceTemplateSheetComponent } from 'src/app/tools/templatesheets/terms-of-service-template-sheet/terms-of-service-template-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { WindorefService } from 'src/app/services/window/windoref.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterContentInit {
  @Input() systemLogo: boolean = false;
  @Input() raysBox: boolean = true;
  public sys: string;
  public subs: Subscription;
  public lang: any = Language.currentLanguage.lenid;
  public addFixedBoxheight: boolean = false;
  public positionFixed = false;
  public currentYear: number = new Date().getFullYear();
  public showFooter = false;

  constructor(
    public _globalsService: GlobalsService,
    private _fixedBoxControl: FixedBoxControlService,
    private _sheet: MatBottomSheet,
    private _window: WindorefService,
    private _router: Router
  ) {
    this._router.events.subscribe((val) => {
      const href = window.location.href;
      this.showFooter = href.includes('/in-maintenance');
    });
  }

  ngAfterContentInit(): void {
    this.setSystemLogo();
    this.setFixedBox();
    this.hideFooter();
  }

  setSystemLogo(): void {
    this.sys = this._globalsService.getSystem().site;
  }

  setFixedBox(): void {
    this._fixedBoxControl.isFixedBoxShowed$.subscribe((isShowed) => {
      this.addFixedBoxheight = isShowed;
    });
  }

  openTerminsAndPolicy(typeOfSheet: number) {
    if (typeOfSheet === 1) {
      this._sheet.open(PrivatePolicyTemplateSheetComponent);
    }
    if (typeOfSheet === 2) {
      this._sheet.open(TerminsAndConditionsTemplateSheetComponent);
    }
    if (typeOfSheet === 3) {
      this._sheet.open(TerminsOfServiceTemplateSheetComponent);
    }
  }

  hideFooter(): void {
    const path = this._window.getNativeDocument().location.pathname;
    this.showFooter = path.includes('/in-maintenance');
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
